"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.avatarNovoDark = exports.avatarNovo = exports.avatarSize = exports.avatarUserStatus = exports.avatar = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const { novo, novoDark } = oxygen_theme_1.default;
// Classic
const avatar = {
    size3xsmall: '16px',
    size2xsmall: '24px',
    sizeXsmall: '32px',
    sizeSmall: '40px',
    sizeMedium: '48px',
    sizeLarge: '64px',
    sizeXlarge: '72px',
    size2xlarge: '80px',
    size3xlarge: '160px',
    font3xsmall: '7px',
    font2xsmall: '10px',
    fontXsmall: '12px',
    fontSmall: '13px',
    fontMedium: '15px',
    fontLarge: '15px',
    fontXlarge: '19px',
    font2xlarge: '19px',
    font3xlarge: '36px',
    icon3xsmall: 10,
    icon2xsmall: 14,
    iconXsmall: 19,
    iconSmall: 24,
    iconMedium: 28,
    iconLarge: 38,
    iconXlarge: 44,
    icon2xlarge: 44,
    icon3xlarge: 76,
    avatarBackgroundColor: color_const_1.default.cloudyBlue,
    borderColor: color_const_1.default.steel700,
    initialsColor: color_const_1.default.pickledBluewood800,
    initialsFontFamily: font_const_1.default.family,
    placeholderIconColor: color_const_1.default.steel700,
    editOverlayColor: color_const_1.default.steel700,
    editIconColor: color_const_1.default.white,
    editIconSmallSize: size_const_1.default.default2x,
    editIconLargeSize: size_const_1.default.medium,
};
exports.avatar = avatar;
// Novo
const avatarNovo = {
    ...avatar,
    size2xsmall: novo.spacing06,
    sizeXsmall: novo.spacing07,
    sizeSmall: novo.spacing08,
    sizeMedium: novo.spacing09,
    fontXsmall: novo.label01.fontSize,
    fontSmall: novo.label01.fontSize,
    fontMedium: novo.body02.fontSize,
    fontLarge: novo.body02.fontSize,
    icon2xsmall: 16,
    iconXsmall: 20,
    iconSmall: 24,
    iconMedium: 32,
    avatarBackgroundColor: novo.ui01,
    borderColor: novo.ui06,
    initialsColor: novo.textColor01,
    initialsFontFamily: novo.body02.fontFamily,
    placeholderIconColor: novo.icon01,
    editOverlayColor: novo.icon01,
    editIconColor: novo.ui06,
    hoverOverlayColor: novo.ui07,
    focusBorderColor: novo.action01,
    innerBorderColor: novo.ui06,
    iconSet: 'novo',
};
exports.avatarNovo = avatarNovo;
// Novo Dark
const avatarNovoDark = {
    ...avatarNovo,
    avatarBackgroundColor: novoDark.ui01,
    borderColor: novoDark.ui06,
    initialsColor: novoDark.textColor01,
    placeholderIconColor: novoDark.icon01,
    editOverlayColor: novoDark.icon01,
    editIconColor: novoDark.ui06,
    hoverOverlayColor: novoDark.ui07,
    focusBorderColor: novoDark.action01,
    innerBorderColor: novoDark.ui06,
};
exports.avatarNovoDark = avatarNovoDark;
const avatarSize = {
    size3xsmall: '3xsmall',
    size2xsmall: '2xsmall',
    sizeXsmall: 'xsmall',
    sizeSmall: 'small',
    sizeMedium: 'medium',
    sizeLarge: 'large',
    sizeXlarge: 'xlarge',
    size2xlarge: '2xlarge',
    size3xlarge: '3xlarge',
};
exports.avatarSize = avatarSize;
const avatarUserStatus = {
    available: 'available',
    away: 'away',
    busy: 'busy',
    doNotDisturb: 'doNotDisturb',
    onBreak: 'onBreak',
    onCall: 'onCall',
    onDirectCall: 'onDirectCall',
    offline: 'offline',
    workingOffline: 'workingOffline',
};
exports.avatarUserStatus = avatarUserStatus;
